import { salesHttp } from "@salesdi";
import repositories from "./repositories";
import usecases from "./useCases";
import presenter from "./presenter";
var cRepositories = repositories(salesHttp);
var cUseCases = usecases(cRepositories);
var cPresenter = presenter(cUseCases);
export default {
    downloads: cPresenter.downloads,
};
